import { useEffect } from 'react'
import { Stack, Typography, Box, Card } from '@mui/material'
import { styled } from '@mui/material/styles';

import { useTranslation } from 'react-i18next';

import LoginForm from '../components/forms/LoginForm'

function Login() {
  const StyledCard = styled(Card)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
    padding: theme.spacing(4),
    gap: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      width: '450px',
    },
    boxShadow:
      'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
    ...theme.applyStyles('dark', {
      boxShadow:
        'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
    }),
  }));

  const { t } = useTranslation()

  useEffect(() => {
    document.title = t("login.page_title")
  }, [])

  return (
    <Stack
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        height: '100dvh',
        p: 2,
        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
      }}
    > 
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <img src="/Logo24Safety.png" alt="Safety24 Logo" width={200} style={{ marginBottom: '16px' }} />
      </Box>
      <StyledCard variant="outlined" sx={{ borderRadius: 3 }}>
        <Stack spacing={2}>
          <Typography 
            variant="h4" 
            fontWeight='600' 
            sx={{ 
              color: '#1e293b',
              textAlign: 'center',
              mb: 1
            }}
          >
            {t("login.login_text")}
          </Typography>
          <LoginForm />
        </Stack>
      </StyledCard>
    </Stack>
  )
}

export default Login
